import { Badge, Button, FloatingToolbar, Row } from '@rematter/ui-web';
import {
  LucideCheck,
  LucideDownload,
  LucidePrinter,
  LucideUndo,
  LucideX,
} from 'lucide-react';

import { useTranslations } from '@/finance/i18n/useTranslations';
import { PaymentRecord } from '~/modules/finance/types';

type Props = {
  selectedRows: PaymentRecord[];
  onConfirm: (rows: PaymentRecord[]) => void;
  onUnconfirm: (rows: PaymentRecord[]) => void;
  onGenerateAchFile: () => void;
  onPrintChecks: () => void;
  onClearSelection: () => void;
};

export const PaymentsBulkToolbar = ({
  selectedRows,
  onConfirm,
  onUnconfirm,
  onGenerateAchFile,
  onPrintChecks,
  onClearSelection,
}: Props) => {
  const t = useTranslations();

  const hasAchPayments = selectedRows.some((r) => r.paymentMethod === 'ACH');
  const hasCheckPayments = selectedRows.some(
    (r) => r.paymentMethod === 'Check',
  );

  return (
    <FloatingToolbar
      visible={selectedRows.length > 0}
      className="@PaymentsBulkToolbar"
    >
      <Row yCenter xBetween gap3>
        <Row yCenter gap2 className="text-sm">
          <Badge color="primary" size="small">
            {selectedRows.length}
          </Badge>
          {t.payments.list.toolbar.selected}
        </Row>
        <Row gap2>
          <Button
            variant="solid"
            color="success"
            icon={<LucideCheck className="size-4" />}
            onPress={() => onConfirm(selectedRows)}
          >
            {t.payments.list.bulkActions.confirm}
          </Button>
          <Button
            variant="outline"
            color="warning"
            icon={<LucideUndo className="size-4" />}
            onPress={() => onUnconfirm(selectedRows)}
          >
            {t.payments.list.bulkActions.unconfirm}
          </Button>
          {hasAchPayments && (
            <Button
              variant="outline"
              color="primary"
              icon={<LucideDownload className="size-4" />}
              onPress={onGenerateAchFile}
            >
              {t.payments.list.toolbar.generateAchFile}
            </Button>
          )}
          {hasCheckPayments && (
            <Button
              variant="outline"
              color="primary"
              icon={<LucidePrinter className="size-4" />}
              onPress={onPrintChecks}
            >
              {t.payments.list.toolbar.printChecks}
            </Button>
          )}
        </Row>
        <LucideX
          className="size-4 cursor-pointer text-neutral/80"
          onClick={onClearSelection}
        />
      </Row>
    </FloatingToolbar>
  );
};
